import React from 'react';

type ContactComponentProps = {
  children: JSX.Element;
};

function Contact({ children }: ContactComponentProps) {
  return <div className="contact__route">{children}</div>;
}

export default Contact;
